import { defineMessages } from 'react-intl';

export const messages: {
	copyright: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	privacyPolicy: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	terms: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	impressum: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	language: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	copyright: {
		id: 'twg-microsite.footer.brand.copyright',
		defaultMessage: 'Copyright © 2026',
		description: 'Footer copyright text shown in the brand column',
	},
	privacyPolicy: {
		id: 'twg-microsite.footer.brand.privacyPolicy',
		defaultMessage: 'Privacy policy',
		description: 'Footer link to the privacy policy in the brand column',
	},
	terms: {
		id: 'twg-microsite.footer.brand.terms',
		defaultMessage: 'Terms',
		description: 'Footer link to the terms of service in the brand column',
	},
	impressum: {
		id: 'twg-microsite.footer.brand.impressum',
		defaultMessage: 'Impressum',
		description: 'Footer link to the legal impressum in the brand column',
	},
	language: {
		id: 'twg-microsite.footer.brand.language',
		defaultMessage: 'English',
		description:
			'Label indicating the currently selected language at the bottom of the brand column',
	},
});
